import React, { useEffect, useMemo } from 'react';
import { Checkbox, Grid, Typography } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import _get from 'lodash/get';
import _keyBy from 'lodash/keyBy';
import DateFnsUtils from '@date-io/date-fns';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import SideBarListStyles from '../../styles/SideBarListStyle';
import ShowProgress from '../ui/Backdrop';

import AntSwitch from '../dailydose/AntSwitch';

import {
  getCheckedAssignedJourneys,
  getCheckedJourneys,
  getMandatoryJourneys,
  getDealershipAssignedJourneys,
} from '../../redux/actions/DealershipActions';

export default function SelectedListItem(props) {
  const journeylist = props.listVal;
  const classes = SideBarListStyles();
  const dispatch = useDispatch();

  const departmentID = useSelector((state) => state.getDepartment);
  const assignedJourneys = useSelector((state) => state.getAssignedJourneys.assignedJourneys);
  const mandatoryJourneys = useSelector((state) => state.getMandatoryJourneys.mandatoryJourneys);
  const dealershipAssignedJourneys = useSelector(
    (state) => state.getDealershipAssignedJourneys.dealershipAssignedJourneys,
  );
  const checkedVals = useSelector((state) => state.getCheckedAssignedJourneys.checkedAssignedJourneys);
  const checkedJourneys = useSelector((state) => state.getCheckedJourneys.checkedJourneys);
  const roleID = useSelector((state) => state.getSelectedRoleID);

  const assignedJourneysMap = _keyBy(assignedJourneys, 'id');

  useEffect(() => {
    const selectedCheck = [];
    const selJourney = [];
    journeylist?.forEach((data, key) => {
      assignedJourneys?.forEach((data1) => {
        if (data.id === data1.id) {
          selectedCheck.push(key);
          selJourney.push(data.id);
        }
      });
    });

    dispatch(getCheckedAssignedJourneys(selectedCheck));
    dispatch(getCheckedJourneys(selJourney));
  }, []);

  const handleDateChange = (id, dates) => {
    dispatch(getDealershipAssignedJourneys('dateRange', { id, dates }));
  };

  const setMandatoryFlag = (e) => {
    if (e.target.checked === true) {
      dispatch(getMandatoryJourneys('append', parseInt(e.target.id, 10)));
    } else {
      const index = mandatoryJourneys?.indexOf(parseInt(e.target.id, 10));
      if (index > -1) {
        dispatch(getMandatoryJourneys('remove', parseInt(e.target.id, 10)));
      }
    }
  };
  function checkMand(id) {
    if (mandatoryJourneys?.indexOf(id) >= 0) {
      return true;
    }
    return false;
  }
  const setDealershipAssignedFlag = (e, data) => {
    dispatch(getDealershipAssignedJourneys('checkbox', { id: parseInt(e.target.id, 10), checked: e.target.checked }));
    if (e.target.checked) {
      const valStartDate = _get(dealershipAssignedJourneys, `${data.id}.startDate`, data.startDate || new Date());
      const valEndDate = _get(dealershipAssignedJourneys, `${data.id}.endDate`, data.endDate);
      dispatch(
        getDealershipAssignedJourneys('dateRange', {
          id: data.id,
          dates: { startDate: valStartDate, endDate: valEndDate },
        }),
      );
    }
  };
  function checkDealerAssign(id, defaultAssigned) {
    return !!_get(dealershipAssignedJourneys, `${id}.dealershipAssigned`, defaultAssigned);
  }
  const handleListItemClick = (event, index, key) => {
    if (checkedVals) {
      const currentIndex = checkedVals?.indexOf(key);
      const currentSelIndex = checkedJourneys?.indexOf(index);
      const newChecked = [...checkedVals];
      const newSel = [...checkedJourneys];

      if (currentSelIndex === -1) {
        newChecked?.push(key);
        newSel?.push(index);
      } else {
        newChecked?.splice(currentIndex, 1);
        newSel?.splice(currentSelIndex, 1);
      }
      dispatch(getCheckedAssignedJourneys(newChecked));
      dispatch(getCheckedJourneys(newSel));
    }
  };

  const journeyFinalList = useMemo(() => {
    if (departmentID === 0 || roleID === 0) {
      return journeylist?.filter((i) => checkedJourneys?.includes(i.id));
    }
    return journeylist;
  }, [journeylist, checkedJourneys, departmentID, roleID]);

  return (
    <div
      className={classes.root}
      style={{
        height: '80%',
        overflow: 'auto',
        marginTop: '16px',
      }}
    >
      {journeyFinalList?.map((data, key) => {
        const index = data.id;
        const isChecked = checkedJourneys?.includes(data.id);
        const assignData = _get(assignedJourneysMap, `${data.id}`, {});
        const valStartDate = _get(dealershipAssignedJourneys, `${data.id}.startDate`, assignData.startDate);
        const valEndDate = _get(dealershipAssignedJourneys, `${data.id}.endDate`, assignData.endDate);

        return (
          <div
            key={data.id}
            style={{ marginBottom: '12px', marginTop: '12px', border: '1px solid #E4E7EC', padding: '15px' }}
          >
            <Grid container direction="row">
              <Grid item xs={1}>
                <Checkbox
                  checked={!!isChecked}
                  onChange={(event) => handleListItemClick(event, index, key)}
                  name="checkedBox"
                  color="primary"
                  disabled={departmentID === 0 || roleID === 0}
                />
              </Grid>
              <Grid item xs={11}>
                <Grid container direction="column" justifyContent="center" alignItems="flex-start">
                  <Grid item>
                    <Typography className={classes.listTextSelectedAj}>{data.title}</Typography>
                  </Grid>
                  <Grid item container direction="row" style={{ paddingTop: '10px' }}>
                    <Grid xs={3} item>
                      <Grid component="label" container direction="row" alignItems="center">
                        <Grid item>
                          <AntSwitch
                            id={data.id}
                            key={data.id}
                            defaultChecked={checkMand(data.id)}
                            onChange={setMandatoryFlag}
                            inputProps={{ 'aria-label': 'ant design' }}
                            disabled={!isChecked || departmentID === 0 || roleID === 0}
                          />
                        </Grid>
                        <Grid item className={classes.listSubTextNonSelected}>
                          Mandatory
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid xs={9} item direction="column" style={{ paddingLeft: '30px' }}>
                      <Grid container>
                        <Grid item component="label" container direction="row">
                          <Grid item>
                            <AntSwitch
                              id={data.id}
                              key={data.id}
                              defaultChecked={checkDealerAssign(data.id, assignData.dealershipAssigned)}
                              onChange={(e) => setDealershipAssignedFlag(e, assignData)}
                              inputProps={{ 'aria-label': 'ant design' }}
                              disabled={!isChecked}
                            />
                          </Grid>
                          <Grid item className={classes.listSubTextNonSelected}>
                            Dealer Recommended
                          </Grid>
                        </Grid>
                        {checkDealerAssign(data.id, assignData.dealershipAssigned) && (
                          <Grid item container direction="row">
                            <Grid item>
                              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <KeyboardDatePicker
                                  placeholder="YYYY-MM-DD"
                                  value={valStartDate}
                                  InputProps={{
                                    disableUnderline: true,
                                    classes: {
                                      input: classes.resize2,
                                    },
                                  }}
                                  onChange={(date) =>
                                    handleDateChange(index, { startDate: date, endDate: valEndDate || valStartDate })
                                  }
                                  format="yyyy-MM-dd"
                                  maxDate={valEndDate}
                                  disabled={!isChecked}
                                />
                              </MuiPickersUtilsProvider>
                            </Grid>
                            <Grid item>
                              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <KeyboardDatePicker
                                  placeholder="YYYY-MM-DD"
                                  value={valEndDate || valStartDate}
                                  InputProps={{
                                    disableUnderline: true,
                                    classes: {
                                      input: classes.resize2,
                                    },
                                  }}
                                  onChange={(date) =>
                                    handleDateChange(index, { startDate: valStartDate, endDate: date })
                                  }
                                  format="yyyy-MM-dd"
                                  minDate={valStartDate || new Date()}
                                  disabled={!isChecked}
                                />
                              </MuiPickersUtilsProvider>
                            </Grid>
                          </Grid>
                        )}
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </div>
        );
      })}
      <ShowProgress />
    </div>
  );
}
